window.Products.HomeDecor.AluminumPrint = function() {};
window.Products.HomeDecor.AluminumPrint.inherits(window.Products.HomeDecor.HomeDecor);